import { ResolveFn } from '@angular/router';
import {GarfieldGovernmentList} from '../../models/government-list/garfield-government-list';
import {inject} from '@angular/core';
import {FitApiService} from '../api/fit-api/fit-api.service';
import {combineLatest} from 'rxjs';
import {map} from 'rxjs/operators';

/**
 * Resolve Government List for non-financial pages
 *
 * @param route
 * @param state
 */
export const garfieldGovernmentListResolver: ResolveFn<GarfieldGovernmentList> = (route, state) => {
	const fitApiService = inject(FitApiService);
	return combineLatest([
		fitApiService.governmentTypesForList,
		fitApiService.countiesForList,
		fitApiService.accountingBases
	]).pipe(map(([governmentTypes, countiesForList, accountingBases]) => {
		return new GarfieldGovernmentList(route, governmentTypes, countiesForList, accountingBases);
	}))

};
